import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

interface CardHeaderProps {
  title?: string; // title is optional
  icon?: IconProp; // the icon is passed as a string representing the icon name
}

const CardHeader: React.FC<CardHeaderProps> = ({ title, icon }) => {
  return (
    <>
      {(title || icon) && (
        <div className="card-header" style={{ paddingBottom: '10px' }}>
          <div className="card-header-content">
            <div
              style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}
            >
              {icon && <FontAwesomeIcon icon={icon} />}
              {title && <h3 style={{ margin: 0 }}>{title}</h3>}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CardHeader;
